var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 0.7,
    clipRule: "evenodd",
    d: "M4 14.0004C4 8.47731 8.47731 4 14.0004 4C19.5234 4 24.0007 8.47731 24.0007 14.0004C24.0007 19.5234 19.5234 24.0007 14.0004 24.0007C8.47731 24.0007 4 19.5234 4 14.0004ZM14.0004 2C7.37275 2 2 7.37275 2 14.0004C2 20.628 7.37275 26.0007 14.0004 26.0007C20.628 26.0007 26.0007 20.628 26.0007 14.0004C26.0007 7.37275 20.628 2 14.0004 2ZM14.5479 9.04797C14.5479 8.49569 14.1001 8.04797 13.5479 8.04797C12.9956 8.04797 12.5479 8.49569 12.5479 9.04797V14.7048C12.5479 14.97 12.6532 15.2244 12.8407 15.4119L16.8407 19.4119C17.2313 19.8025 17.8644 19.8025 18.255 19.4119C18.6455 19.0214 18.6455 18.3882 18.255 17.9977L14.5479 14.2906V9.04797Z",
    fill: "#151C22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.276ce734.svg";
export { ForwardRef as ReactComponent };